module.exports = __webpack_public_path__ + "static/media/miniplating.ac64c877.png";